import { Subject } from 'rxjs/internal/Subject';
import { Loader, unwrapLoader } from '@/utils/signals/loader';

export const tryWithLoading = async <T>(loading$: Subject<boolean>, load: () => Promise<T>): Promise<T> => {
  try {
    loading$.next(true);
    return await load();
  } finally {
    loading$.next(false);
  }
};

export const tryWithLoadingSignal = async <T>(loader: Loader, load: () => Promise<T>): Promise<T> => {
  const signal = unwrapLoader(loader);
  const subject$ = new Subject<boolean>();
  subject$.subscribe((val) => {
    signal.set(val);
  });
  return tryWithLoading(subject$, load);
};
